<template>
  <div class="main">
    <div class="nav">
      <Nav title="核酸检测"></Nav>
      <div class="top"></div>
    </div>
    <div class="card_body">
      <van-notice-bar
        left-icon="volume-o"
        :text="minutes+'分'+seconds+'秒后将关闭订单页'"
      />
      <div class="card" v-for="(item, index) in infolist" :key="index">
        <div class="card_cell">
          <div class="card_cell_title">项目</div>
          <div>{{ item.itemName }}</div>
        </div>
        <div class="card_cell">
          <div>单价</div>
          <div>￥：{{ item.totCost }}</div>
        </div>
        <div class="card_cell">
          <div>次数</div>
          <div>1次</div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="foot_info">
        <div class="foot_name">姓名:{{ showname }}</div>
        <div class="foot_cardno">就诊卡：{{ shownum }}</div>
      </div>
      <div class="totFee">总金额：￥:{{ totFee }}</div>
      <div class="tips">如不清楚检测点，请到导医台咨询</div>
    </div>
    <div class="pay_btn">
      <van-button type="info" block @click="gopay()">确认支付</van-button>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      medCardNo: "",
      infolist: [],
      totFee: "",
      showname: "",
      shownum: "",
      registerId: "",
      recipeId: "",
      payWay: "",
      //wx支付需要参数
      appId: "",
      timeStamp: "",
      nonceStr: "",
      package: "",
      signType: "",
      paySign: "",
      out_trade_no: "",
      cacheKey: "",
      timer: null,
      minutes: 1,
      seconds: 30,
      time: null,
    };
  },
  methods: {
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, //公众号名称，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: nonceStr, //随机串
          package: pacKage,
          signType: signType, //微信签名方式：
          paySign: paySign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$showLoad("支付确认中...");
            this.timer = setTimeout(() => {
              this.$hideLoad();
              this.$router.push({
                path: "/ODpay_history_C",
                query: {
                  name: this.name,
                  clientId: this.shownum,
                },
              });
            }, 4000);
          }
        }
      );
    },
    add() {
      var _this = this;
      this.time = setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          clearInterval(_this.time);
          _this.$toast.fail("订单超时，返回首页");
          setTimeout(() => {
            _this.$router.push("/index");
          }, 1000);
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.payWay = data.data.objType[0].paykey;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    async gopay() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/unifiedorder";
        let data = {
          registerId: this.registerId,
          recipeId: this.cacheKey,
          clientId: this.shownum,
          payWay: this.payWay,
          totFee: this.totFee,
          mode: "outpatient", //处方缴费
          body: "门诊缴费 ",
          detail: "门诊缴费",
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
         
            this.appId = data.data.result_uninorder.appId;
            this.timeStamp = data.data.result_uninorder.timeStamp;
            this.nonceStr = data.data.result_uninorder.nonceStr;
            this.pacKage = data.data.result_uninorder.package;
            this.signType = data.data.result_uninorder.signType;
            this.paySign = data.data.result_uninorder.paySign;
            this.out_trade_no = data.data.out_trade_no;
            // this.out_trade_no = data.data.out_trade_no;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  ),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  )
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  )
                );
              }
            } else {
              this.onBridgeReady(
                this.appId,
                this.timeStamp,
                this.nonceStr,
                this.pacKage,
                this.signType,
                this.paySign
              );
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    async getinfo() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/commitacid";
        let data = {
          clientId: this.medCardNo,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
               this.add()
            this.infolist = data.data.data.data.outFeeInfos;
            this.totFee = data.data.data.data.totFee;
            this.showname = this.infolist[0].clientName;
            this.shownum = this.infolist[0].medCardNo;
            this.registerId = this.infolist[0].registerId;
            this.cacheKey = data.data.data.data.cacheKey;
            // this.infolist.forEach(element => {
            //     // this.recipeId.push(element.recipeId)
            //     this.recipeId +=element.recipeId+","

            // });
            this.recipeId = this.infolist[0].recipeId;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
  mounted() {
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
    }
    this.getinfo();
    this.getPayWay();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.main {
  max-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  .card_body {
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    overflow: scroll;
    margin-bottom: 2vh;
    .card {
      display: flex;
      flex-direction: column;
      height: 26vh;
      width: 95%;
      margin: 0px auto;
      margin-top: 1vh;
      margin-bottom: 2vh;
      border: 1px solid white;
      border-radius: 6px;
      background-color: white;
      padding: 8px;
      font-size: 16px;
      .card_cell {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        line-height: 8vh;
        border-bottom: 1px solid #eee;
      }
    }
  }
  .foot {
    background: white;
    width: 95%;
    height: 20vh;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    padding: 5px;
    margin-bottom: 6vh;
    .foot_info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      justify-self: center;
      width: 95%;
      margin: 0px auto;
    }
    .totFee {
      width: 50%;
      margin: 0px auto;
      text-align: center;
      margin-top: 4vh;
      font-size: 18px;
    }
    .tips {
      margin-top: 3vh;
      text-align: center;
    }
  }
}
</style>